import TripDetailsSubHeading from '../../tripDetailsSubHeading/TripDetailsSubHeading';
import './tripTypes.css';

const TripTypes = ({ tripDetailsData }) => {
    return (
        <>
            <TripDetailsSubHeading text={'Types'} />
            <div className='typeDetailsDiv'>
                <span className='typeDetailsSpan'>
                    <strong>Dates Type: </strong>
                    {tripDetailsData?.datesType}
                </span>
                <span className='typeDetailsSpan'>
                    <strong>Group Type: </strong>
                    {tripDetailsData?.group}
                </span>
                <span className='typeDetailsSpan'>
                    <strong>Itinerary Type: </strong>
                    {tripDetailsData?.itiType}
                </span>
            </div>
        </>
    );
};

export default TripTypes;
